import { render } from "datocms-structured-text-to-plain-text"
import React, { useState } from "react"
import { StructuredText } from "react-datocms"

import screenSize from "../../utils/screenResponsive"

import Atlanta from "./components/Atlanta"
import CapeTown from "./components/CapeTown"
import Lagos from "./components/Lagos"
import { MapComponent } from "./components/MapComponent"
import SanFrancisco from "./components/SanFrancisco"
import Statistic from "./components/Statistics"
import Toronto from "./components/Toronto"
import {
  Wrap,
  GlobalTeamWrapper,
  Content,
  HeadingWrapper,
  Heading,
  Body,
  StatisticsWrapper,
  MapWrapper,
  MapArea,
} from "./styles/GobalTeam.styled"
import { Background, TopLine, BottomLine, MobileTopLine } from "./utils/Lines"

const GlobalTeam = ({ component }) => {
  const [showSf, setShowSf] = useState(false)
  const [showAtlanta, setShowAtlanta] = useState(false)
  const [showToronto, setShowToronto] = useState(false)
  const [showCapeTown, setShowCapeTown] = useState(false)
  const [showLagos, setShowLagos] = useState(false)

  const { heading, body, statistics } = component
  const isMobile = screenSize(576)

  return (
    <Wrap>
      <Background className="background" />
      <GlobalTeamWrapper>
        <Content>
          <HeadingWrapper>
            {heading && <Heading>{heading}</Heading>}
            {render(body)?.length > 0 && (
              <Body>
                <StructuredText
                  data={body}
                  renderInlineRecord={({ record }) => {
                    switch (record.model?.apiKey) {
                      case "component_call_to_action":
                        return (
                          <a className="arrow-link" href={record?.url}>
                            {record?.label}
                          </a>
                        )
                      default:
                        return null
                    }
                  }}
                  renderBlock={() => {}}
                />
              </Body>
            )}
          </HeadingWrapper>
        </Content>
        {statistics && (
          <StatisticsWrapper num={statistics.length}>
            {statistics.map((stat) => (
              <Statistic key={stat.id} stat={stat} />
            ))}
          </StatisticsWrapper>
        )}
        <MapWrapper>
          {!isMobile && <TopLine className="top-line" />}
          {isMobile && <MobileTopLine className="top-line" />}
          <BottomLine className="bottom-line" />
          <MapArea>
            <MapComponent />
            <SanFrancisco showSf={showSf} setShowSf={setShowSf} />
            <Atlanta
              showAtlanta={showAtlanta}
              setShowAtlanta={setShowAtlanta}
            />
            <Toronto
              showToronto={showToronto}
              setShowToronto={setShowToronto}
            />
            <CapeTown
              showCapeTown={showCapeTown}
              setShowCapeTown={setShowCapeTown}
            />
            <Lagos showLagos={showLagos} setShowLagos={setShowLagos} />
          </MapArea>
        </MapWrapper>
      </GlobalTeamWrapper>
    </Wrap>
  )
}

export default GlobalTeam
